
































import { Component, Prop, Vue } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'

import { Brand, PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

@Component({
	components: {
		UiButton,
		UiModal,
	},
})
export default class BrandList extends Vue {

	$refs!: {
		'delete-confirmation-modal': UiModal
	}

	@Prop()
	readonly filter?: string

	pendingDeletedBrand = { $id: '', name: '' }

	get brands(): Brand[] {

		const { brands } = grocery

		if (!this.filter) {
			return brands
		}

		const filter = this.filter.toLocaleLowerCase()

		return brands.filter(b => b.name.toLocaleLowerCase().includes(filter))
	}

	deleteBrand(): boolean {

		grocery.deleteBrand(this.pendingDeletedBrand.$id)

		return true
	}

	getBrandPantryItems(brandId: string): PantryItem[] {

		return (grocery.brandPantryItems[brandId] || [])
			.map(i => grocery.pantryItemsCollection[i])
			.filter<PantryItem>((i): i is PantryItem => !!i)
			.sort((a, b) => a.name.localeCompare(b.name))
	}

	promptDeleteBrand(brand: Brand): void {

		this.pendingDeletedBrand = brand
		this.$refs['delete-confirmation-modal'].show()
	}

}

